import { useEffect } from 'react';
import { useFeature } from 'flagged';
import chatService from '../../services/chatService';

export const CHAT_ENABLED_CLASS = 'dpx-chat-enabled';

const AmazonConnectChat = ({
  providerId,
  professionalId,
  displayName,
}) => {
  const chatEnabled = useFeature('featureEnabler/amazonConnectChat');

  useEffect(() => {
    if (!chatEnabled || !providerId || !professionalId)
      return undefined;

    // Read by the amazon_connect callbacks in public/index.html
    window.dpxChat = {
      displayName,
      getToken: () =>
        chatService.getChatToken(providerId, professionalId),
    };
    document.body.classList.add(CHAT_ENABLED_CLASS);

    return () => {
      delete window.dpxChat;
      document.body.classList.remove(CHAT_ENABLED_CLASS);
    };
  }, [chatEnabled, providerId, professionalId, displayName]);

  return null;
};

export default AmazonConnectChat;
